import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';

type SaveAssetDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  children: React.ReactNode;
};

export function SaveAssetDialog({ isOpen, onClose, isLoading, children }: SaveAssetDialogProps) {
  return (
    <Dialog fullWidth open={isOpen} onClose={onClose} PaperProps={{ sx: { position: 'relative' } }}>
      {isLoading && (
        <Stack
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          component="div"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex={1}
          sx={{
            backgroundColor: 'action.disabled',
          }}
        >
          <CircularProgress />
        </Stack>
      )}
      {children}
    </Dialog>
  );
}

export function SaveAssetDialogContent({ children }: { children: React.ReactNode }) {
  return (
    <DialogContent>
      <FormControl fullWidth>{children}</FormControl>
    </DialogContent>
  );
}
